module.exports = __webpack_public_path__ + "assets/img/64b45ac40d1a36830fc812cf39c9586c.svg";